import React, { useMemo, useRef } from 'react';
import { getVideoTimeAsHHMMSS } from '../../../../utils/utils';

interface Props {
	totalSeconds: number,
	secondsInterval: number,
	minTimestamps: number
}

export default function TimeTrack(props: Props) {
	const { totalSeconds, secondsInterval, minTimestamps } = props;
	const wrapperRef = useRef<HTMLDivElement | null>(null);

	const renderedTimestamps = useMemo(() => {
		let nTotalTimestamps = totalSeconds / secondsInterval;
		if(nTotalTimestamps < minTimestamps) {
			nTotalTimestamps = minTimestamps;
		}
		const nRenderedTimestamps = [];
		for (let i = 0; i <= nTotalTimestamps; i++) {
			nRenderedTimestamps.push(getVideoTimeAsHHMMSS(i * secondsInterval));
		}
		return nRenderedTimestamps;
	}, [totalSeconds, secondsInterval, minTimestamps]);

	return (
		<div 
			ref={wrapperRef}
			className='tt-time-track'
		>
			{renderedTimestamps.map((timestamp: string) => {
				return (
					<div className="track-section" key={timestamp}>
						<div>{timestamp}</div>
						<div className='mini-divider'></div>
					</div>
				);
			})}
		</div>
	);
}